<template>
	<div class="tableSelect">
		<h2 style="text-align: center;margin-bottom: 15px;">新增文章</h2>
		<el-form :model="article" :rules="rules" ref="form" label-width="150px" style="width:100%;">
			<el-form-item label="封面" prop="cover"
				:rules="article.category == newsId?[{required: true,message: '请上传文章封面',trigger: 'blur'}]:[]">
				<el-upload style='width:100px;' drag :data="{dirs:'article'}" :action="url+'article/upload/'"
					:show-file-list="false" :headers="{Authorization:'JWT '+token}" :before-upload="beforeUploadHandler"
					:on-success="fileSuccess">
					<el-icon class="avatar-uploader-icon" v-if="!article.cover">
						<Plus />
					</el-icon>
					<el-image v-else :src="'http://' + mediaUrl + '/media'+article.cover"></el-image>
				</el-upload>
			</el-form-item>
			<el-form-item label="文章标题" prop="title">
				<el-input v-model.trim="article.title" placeholder="请输入文章标题"></el-input>
			</el-form-item>
			<el-form-item label="文章类别" prop="category">
				<el-radio-group v-model="article.category">
					<el-radio :value="item.id" v-for="item in categorys">{{item.name}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="文章栏目" prop="column">
				<el-tree
					style="width: 100%; max-height: 300px; overflow-y: auto;"
					ref="columnTree"
					node-key="id"
					:props="treeProps"
					:data="columnsData"
					default-expand-all
					show-checkbox
				/>
			</el-form-item>
			<el-form-item label="作者" prop="author">
				<el-input v-model.trim="article.author" placeholder="请输入作者名称"></el-input>
			</el-form-item>
			<el-form-item label="部门" prop="dept">
				<el-cascader style="width: 100%" :show-all-levels="false" :options="depts" v-model="article.dept"
					:props="{ checkStrictly: true ,label:'name',value:'id'}" clearable></el-cascader>
			</el-form-item>
			<el-form-item label="关键字" prop="keywords">
				<el-input v-model="article.keywords" placeholder="请输入关键字"></el-input>
			</el-form-item>
			<el-form-item prop="sort">
				<template #label>
					<div style="display: flex;align-items: center;">
						<span style="margin-right: 6px;">排序</span>
						<el-tooltip content="数值越小权重越小" placement="right">
							<el-icon>
								<QuestionFilled />
							</el-icon>
						</el-tooltip>
					</div>
				</template>
				<el-input-number :min="$route.query.sort" v-model="article.sort" placeholder="请输入排序号"></el-input-number>
			</el-form-item>
			<el-form-item label="是否开放评论区" prop="comments_open">
				<el-radio-group v-model="article.comments_open">
					<el-radio :value="true">是</el-radio>
					<el-radio :value="false">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="文章内容" prop="content">
				<TEditor
					v-model.trim="article.content"
					:style="{ heigth: '600px' }"
				></TEditor>
			</el-form-item>
			<el-form-item :label="article.category==noticeId ?'弹窗开始时间':'发布时间'" prop="publish_time"
				:rules="[{required: true,message: `请选择${article.category==noticeId ?'弹窗开始时间':'发布时间'}`,trigger: 'blur'}]">
				<el-date-picker
					style="width:100%;"
					v-model="article.publish_time"
					value-format="YYYY-MM-DD HH:mm:ss"
					type="datetime"
					:placeholder="`请选择${article.category==noticeId ?'弹窗开始时间':'发布时间'}`"
					:teleported="false"
					popper-class="date-picker-popper"
				/>
			</el-form-item>
			<el-form-item v-if="article.category==noticeId" label="弹窗结束时间" prop="popup_timer"
				:rules="[{required: true,message: '请选择弹窗结束时间',trigger: 'blur'}]">
				<el-date-picker
					style="width:100%;"
					v-model="article.popup_timer"
					value-format="YYYY-MM-DD HH:mm:ss"
					type="datetime"
					placeholder="请选择弹窗结束时间"
					:teleported="false"
					popper-class="date-picker-popper"
				/>
			</el-form-item>
			<el-form-item label="文章附件">
				<el-upload style='width:100%;' :action="url+'article/upload/'" drag :limit="5" :data="{dirs:'attachments'}"
					:headers="{Authorization:'JWT '+token}" :before-upload="attachBefore" :on-success="attachSuccess"
					:on-exceed="exceedHandler" :on-remove="remorveFile">
					<el-icon class="el-icon--upload"><upload-filled /></el-icon>
					<div class="el-upload__text">拖拽文件到这 或 <em>点击上传</em></div>
				</el-upload>
			</el-form-item>
		</el-form>
		<div style="display: flex;justify-content: center;border-top: 1px solid #ddd;margin: 0 -7px;padding-top: 15px;">
			<el-button type="success" @click="saveDraft" style="width: 120px;">保存为草稿</el-button>
			<el-button type="primary" @click="saveHandler" style="width: 120px;">立即发布</el-button>
			<el-button type="danger" @click="cancel" style="width: 120px;">取消</el-button>
		</div>
	</div>
</template>

<script setup>
	import {
		url,
		mediaUrl
	} from '@/api/url'
	import {
		getToken,
		buildTree
	} from '@/utils/util'
	import TEditor from '@/components/TEditor'
	import {
		useMutitabsStore
	} from "@/store/mutitabs"
	import {
		ElMessage,
		ElMessageBox,
		ElLoading
	} from 'element-plus'
	import {
		articlePost,
		categoryGet,
		columnGet,
		apiSystemDept
	} from "@/api/court"
	import {
		useRouter,
		useRoute
	} from "vue-router"
	import {
		ref,
		reactive,
		onMounted
	} from "vue"

	const mutitabsstore = useMutitabsStore()
	const router = useRouter()
	const route = useRoute()
	const token = getToken()
	const columnTree = ref(null)

	const columnsData = ref([])
	const categorys = ref([])
	const newsId = ref(2)
	const noticeId = ref(3)
	const form = ref(null)
	const depts = ref([])
	const attachs =ref([])
	const treeProps = {
		label:'name',
		value:'id',
		children: 'children',
		disabled: (data,node) => !data.is_enable
	}

	const article = reactive({
		title: "", //文章标题
		author: "", //文章来源
		sort: 0, //排序
		comments_open: false, //是否开放评论区
		status: "published", //状态
		keywords: "", //关键字
		content: "", //文章内容
		publish_time: "", //弹窗开始时间
		popup_timer: "", //弹窗结束时间
		category: 1, //文章类别
		column: route.query.column ? parseInt(route.query.column) : "", //栏目
		cover: "", //封面
		attachments: '', //上传文件
		dept: ''
	})

	const rules = reactive({
		title: [{
				required: true,
				message: '请输入文章标题',
				trigger: 'blur'
			},
			{
				max: 60,
				message: '文章标题最多只能输入60个字符',
				trigger: 'blur'
			}
		],
		category: [{
			required: true,
			message: '请选择文章类别',
			trigger: 'blur'
		}], //文章类别
		author: [{
			required: true,
			message: '请输入作者名称',
			trigger: 'blur'
		}], //作者名称
		sort: [{
			required: true,
			message: '请输入排序号',
			trigger: 'blur'
		}], //排序
		comments_open: [{
			required: true,
			message: '请选择是否开发评论区',
			trigger: 'blur'
		}], //排序
		column: [{
			required: true,
			message: '请选择文章栏目',
			trigger: 'blur'
		}], //栏目
		content: [{
			required: true,
			message: '请输入文章内容',
			trigger: 'blur'
		}], //文章内容
	})

	function initPage() {
		//焦点新闻
		if (route.query.column == '2') {
			article.category = 2
			//通知
		} else if (route.query.column == '117') {
			article.category = 3
			//普通文章
		} else {
			article.category = 1
		}
		columnGet({
			page: 1,
			limit: 10000,
			is_enable: true
		}).then(res => {
			if (res.code == 2000) {
				// console.log('栏目接口返回数据:', res.data.data)

				// 检查数据是否为空
				if (!res.data.data || res.data.data.length === 0) {
					// console.warn('栏目数据为空')
					columnsData.value = []
					return
				}

				// 尝试构建树形结构
				let arr = buildTree(res.data.data)
				// console.log('buildTree处理后的数据:', arr)

				// 如果buildTree返回空数组，可能是因为没有根节点
				if (arr.length === 0) {
					console.warn('buildTree返回空数组，可能缺少根节点，直接使用原始数据')
					// 直接使用原始数据，但需要确保有children属性
					arr = res.data.data.map(item => ({
						...item,
						children: []
					}))
				}

				// 将所有数据分配给单个树组件
				columnsData.value = arr
				// console.log('columnsData:', columnsData.value)
			}
		})
		categoryGet({
			page: 1,
			limit: 10000
		}).then(res => {
			if (res.code == 2000) {
				categorys.value = res.data.data
			}
		})
		apiSystemDept().then(res => {
			if (res.code == 2000) {
				depts.value = buildTree(res.data.data)
			}
		})
	}

	//禁止选择过去的日期
	function disabledDate(data) {
		const current = new Date(Date.now() - (1000 * 60 * 60 * 24))
		return data.getTime() < current.getTime()
	}

	//上传文件校验钩子
	function beforeUploadHandler(file) {
		// if (file.size / 1024 / 1024 > 5) {
		// 	ElMessage.warning("上传文件的大小最大为2MB")
		// 	return false
		// }
		const reg = /(png|jpeg|jpg)$/
		if (!reg.test(file.name)) {
			ElMessage.warning("请上传图片格式的文件")
			return false
		}
		return true
	}

	function fileSuccess(resp) {
		if (resp.code == 2000) {
			article.cover = resp.data.data[0]
		}
	}

	function attachBefore(file) {
		if (file.size / 1024 / 1024 > 300) {
			ElMessage.warning("单个附件最大为300MB")
			return false
		}
		return true
	}

	function attachSuccess(resp) {
		if (resp.code == 2000) {
			attachs.value.push(resp.data.data[0])
			// article.attachments = resp.data.data[0]
		}
	}

	function remorveFile(file,files) {
		const index = attachs.value.indexOf(file.response.data.data[0])
		if(index != -1)attachs.value.splice(index,1)
	}

	//保存为草稿
	function saveDraft() {
		article.status = "draft"
		saveHandler()
	}

	function exceedHandler() {
		ElMessage.warning("文件个数超出限制")
	}

	//立即发布
	function saveHandler() {
		// 获取单个树组件的选中节点
		article.column = columnTree.value.getCheckedKeys()
		form.value.validate(flag => {
			if (flag) {
				const params = JSON.parse(JSON.stringify(article))
				params.dept = Array.isArray(params.dept) ? params.dept[params.dept.length - 1] : params.dept
				// 移除文章内容中的媒体服务器地址
				const mediaUrlRegex = new RegExp(`http://${mediaUrl}/media`, 'g')
				params.content = params.content.replace(mediaUrlRegex, '')
				params.attachments = attachs.value.join(",")

				if(article.category!=noticeId)delete params.popup_timer
				articlePost(params).then(res => {
					if (res.code == 2000) {
						ElMessage.success("新增文章成功")
						router.go(-1)
					}
				})
			}
		})
	}

	//取消
	function cancel() {
		router.go(-1)
	}

	onMounted(_ => {
		initPage()
	})
</script>

<style scoped lang="scss">
	.tableSelect .el-form {
		display: block !important;
	}

	.tableSelect .el-form-item {
		margin-bottom: 15px !important;
	}

	:deep(.el-form .tox .tox-editor-header) {
		z-index: 2800;
	}

	// 修复时间选择器弹出层问题
	:deep(.el-date-picker) {
		z-index: 3000 !important;
	}

	:deep(.el-picker-panel) {
		z-index: 3000 !important;
	}

	:deep(.el-popper) {
		z-index: 3000 !important;
	}
</style>

<style lang="scss">
	// 全局样式，修复时间选择器弹出层定位问题
	.date-picker-popper {
		z-index: 3000 !important;

		.el-picker-panel {
			z-index: 3000 !important;
		}

		.el-date-picker {
			z-index: 3000 !important;
		}

		.el-picker-panel__content {
			z-index: 3000 !important;
		}
	}
</style>